import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { YearsPage } from '@/features/years/years-page';

export const Route = createFileRoute('/_app/settings/years')({
  component: () => (
    <RequireService service="YEAR_MANAGE">
      <YearsPage />
    </RequireService>
  ),
});
